module.exports = __webpack_public_path__ + "static/img/Ivan Yan.fe04d597.png";